module.exports = new __parcel__URL__("holyfortitude.650d21ab.png").toString();